import axios from "axios";
import apiUrl from "../../../urls/apiUrls";

export const getHomepageMetaDta = (request) => {
  const params = new URLSearchParams();
  params.append("page_id", request.params.page);

  var config = {
    method: "POST",
    url: `/meta-data`,
    data: params,
  };

  return new Promise((resolve, reject) => {
    axios(config)
      .then(function (response) {
          resolve(response);
      })
      .catch(function (error) {
        resolve(error);
        resolve(error.response);
      
      });
  });
};
